module.exports = __webpack_public_path__ + "img/t3-1.e06b3c16.svg";